import store from '@/store'

export default [
  {
    path: '/admin/game-set-results',
    name: 'game-set-result',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/game-set-result')
  }
  //   {
  //     path: '/game-settings/create',
  //     name: 'game-setting-create',
  //     meta: { requiresAuth: true },
  //     component: () => import('@/pages/administrator/game-setting/create.vue')
  //   },
  //   {
  //     path: '/game-settings/:id/edit',
  //     name: 'game-setting-edit',
  //     meta: { requiresAuth: true },
  //     component: () => import('@/pages/administrator/game-setting/edit.vue'),
  //     beforeEnter: async (to, from, next) => {
  //       await store.dispatch('administrator/gameSetting/find', to.params.id)
  //       next()
  //     }
  //   }
]
